// gate-authority-grant-carryover.ts
//
// Shared helper for approveGate/waiveGate (gate-registry-transitions.ts /
// gate-registry-waive-invalidate.ts), split into a leaf module so both can
// import it without importing each other.
import type { GateRecord } from "./gate-registry.js";

/**
 * H1 (code-reviewer 260916 phase-04): giữ lại phạm vi quyền đã khai.
 *
 * `approveGate`/`waiveGate` dựng `next: GateRecord` MỚI thay vì spread record
 * cũ — có chủ đích, để một approve không kéo theo `reason`/`authority_ref` của
 * vòng đời trước. Nhưng `targets`/`expires_at` KHÁC bản chất: chúng là phạm vi
 * quyền người khai TRƯỚC khi duyệt, nên xoá chúng lúc duyệt = nới quyền âm
 * thầm từ "chỉ qa/staging, có hạn" thành "mọi target, vô hạn".
 *
 * Input thắng record (người bấm nút là người quyết); không khai thì kế thừa.
 */
export function carryAuthorityGrant(
  record: GateRecord,
  input: { targets?: string[]; expiresAt?: string },
): Pick<GateRecord, "targets" | "expires_at"> {
  const targets = input.targets ?? record.targets;
  const expiresAt = input.expiresAt ?? record.expires_at;
  return {
    ...(targets !== undefined ? { targets } : {}),
    ...(expiresAt !== undefined ? { expires_at: expiresAt } : {}),
  };
}
